/* import __COLOCATED_TEMPLATE__ from './basic-square-logo.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';

/**
## Svgs::BasicSquareLogo

Displays an SVG of the Square Logo. Black lines on transparent background.

### Example usage
hbs```
  <Svgs::BasicSquareLogo />
```
*/

export default class BasicSquareLogo extends SvgIcon {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "height", 34);
    _defineProperty(this, "width", 34);
    _defineProperty(this, "viewBox", '0 0 34 34');
    _defineProperty(this, "defaultColor", 'black');
    _defineProperty(this, "fill", 'none');
    // Inherited from SvgIcon base class, this adds a class that interferes with
    // SVG styling
    _defineProperty(this, "colorClass", null);
  }
}